import { useContext } from "react";
import { CommonComponentContext } from "../utils/CommonComponentContext";

export function useCredentials() {
    const commonContext = useContext(CommonComponentContext);
    return commonContext.credentials;
}

export default useCredentials;